import React, { forwardRef } from "react"
import ContextMenu from "../../../../components/atoms/ContextMenu.atom"
import { reactivateClient } from "../../../../services/client.service"
import { reactivateProject } from "../../../../services/project.service"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../../consts/appRoutes.consts"
import {
  CLIENT_TABLE_ROW_ACTIONS,
  CLIENT_TABLE_ROW_TYPE,
} from "../../../../consts/modules/clients.consts"

const ClientsTableContextMenu = forwardRef((props, ref) => {
  const items = []
  const navigate = useNavigate()
  items.push({
    label: "Editar",
    icon: "pi pi-pencil",
    command: () => {
      if (props.selectedRow?.type === CLIENT_TABLE_ROW_TYPE.CLIENT) {
        props.onEditClient({
          ...props.selectedRow.data,
          id: props.selectedRow.data.clientId,
          budgetType: props.selectedRow.data.clientBudgetTypeId,
        })
      }
      if (props.selectedRow?.type === CLIENT_TABLE_ROW_TYPE.PROJECT) {
        navigate(AppRoutes.clientes.editarProyecto, {
          state: {
            isCreate: false,
            client: {
              id: props.selectedRow.parentKey,
              code: props.selectedRow?.data.clientCode,
              name: props.selectedRow?.data.clientName,
            },
            project: {
              ...props.selectedRow?.data,
              id: props.selectedRow?.data.projectId,
              name: props.selectedRow?.data.name.split("-")[1],
            },
          },
        })
      }
    },
  })
  if (props.selectedRow?.type === CLIENT_TABLE_ROW_TYPE.CLIENT) {
    const selectedClient = props.selectedRow.data
    if (selectedClient?.isBillable) {
      items.push({
        label: "Ver presupuesto",
        icon: "pi pi-wallet",
        command: () => {
          navigate(AppRoutes.clientes.presupuestoCliente, {
            state: {
              id: selectedClient.clientId,
              ...selectedClient,
            },
          })
        },
      })
    }
  }
  if (props.selectedRow?.data?.active) {
    items.push({
      label: "Desactivar",
      icon: "pi pi-ban",
      command: () => {
        props.setOpenModal(true)
        props.setModalAction(CLIENT_TABLE_ROW_ACTIONS.DEACTIVATE)
      },
    })
  } else if (
    props.selectedRow?.data?.isClientActive ||
    props.selectedRow?.isClientActive ||
    props.selectedRow?.type === "client"
  ) {
    items.push({
      label: "Activar",
      icon: "pi pi-check",
      command: async () => {
        if (props.selectedRow?.type === CLIENT_TABLE_ROW_TYPE.CLIENT) {
          await reactivateClient(props.selectedRow?.id)
        } else if (props.selectedRow?.isClientActive) {
          await reactivateProject(props.selectedRow?.id)
        }
        props.setModalAction(CLIENT_TABLE_ROW_ACTIONS.REACTIVATE)
      },
    })
  }
  if (props.selectedRow?.data?.isDeletable) {
    items.push({
      label: "Eliminar",
      icon: "pi pi-trash",
      command: () => {
        props.setOpenModal(true)
        props.setModalAction(CLIENT_TABLE_ROW_ACTIONS.DELETE)
      },
    })
  }
  return <ContextMenu ref={ref} model={items} />
})

export default ClientsTableContextMenu
